import { writable } from "svelte/store";
import { service } from "./services";
import type { ApiResultOfListOfBannersDTO, ApiResultOfListOfGameServerDTO, BannersDTO, GameServerDTO } from "./walletapi";
import { RegisterStartupCallback } from "./startup";

export const banners = writable<BannersDTO[]>([]);

export async function BannerListStartup(firstStartup: boolean) {
    RefreshBanners();

    if (!firstStartup) return;

    service.walletapi.registerOperation("BannerChanged", "BannerList/BannerChanged", BannerChanged);
    service.walletapi.registerOperation("BannerAdded", "BannerList/BannerAdded", BannerAdded);
}

RegisterStartupCallback("ServerListStartup", BannerListStartup);

export async function RefreshBanners() {
    try {
        let response: ApiResultOfListOfBannersDTO = await service.walletapi.bannersList({
            Token: sessionStorage.token,
        });

        if (response.Success && response.Data) {
            banners.set(response.Data);
        } else {
            console.error('Error getting server list:', response.ErrorMessage);
        }
    } catch (error) {
        console.error('API call error:', error);
    }
}

export function BannerChanged(server: BannersDTO) {
    banners.update(banners => {
        const index = banners.findIndex(a => a.Id === server.Id);
        if (index >= 0) {
            banners[index] = server;
        }
        return banners;
    });
}

export function BannerAdded(server: BannersDTO) {
    banners.update(banners => {
        banners = [...banners, server];
        return banners;
    });
}
